import { render, staticRenderFns } from "./StartCompanyItem.vue?vue&type=template&id=2dc0aea0&scoped=true&"
import script from "./StartCompanyItem.vue?vue&type=script&lang=ts&"
export * from "./StartCompanyItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc0aea0",
  null
  
)

export default component.exports